export const apiCode = process.env.REACT_APP_API_CODE;
export const key = process.env.REACT_APP_KEY;
export const domain = process.env.REACT_APP_DOMAIN;
export const aiBaseUrl = process.env.REACT_APP_AI_BASE_URL;

// novo servidor alterar domain no env e homepage no package.json, homolog.

export const useGeminiStream = process.env.REACT_APP_USE_GEMINI_STREAM === 'true';
